import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Headphones } from 'lucide-react';
export function BonusSection() {
  return <section className="py-16 px-6 md:px-8 bg-cream-alt" data-id="element-27">
      <div className="max-w-4xl mx-auto" data-id="element-28">
        <FadeIn data-id="element-29">
          <div className="relative bg-gradient-to-br from-warm-deep to-warm-deeper rounded-3xl p-8 md:p-12 shadow-xl border border-gold/20 overflow-hidden" data-id="element-30">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4" data-id="element-31" />
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-cream/40 rounded-full blur-2xl translate-y-1/4 -translate-x-1/4" data-id="element-32" />

            <div className="relative z-10" data-id="element-33">
              <div className="flex items-center gap-3 mb-6" data-id="element-34">
                <div className="bg-gold text-white px-4 py-2 rounded-full shadow-md font-bold text-sm tracking-wider flex items-center gap-2" data-id="element-35">
                  🎁 BONUS
                </div>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-36">
                🎧 AUDIO SOS — <br className="hidden md:block" data-id="element-37" />
                <span className="font-heading italic font-normal text-gold-dark" data-id="element-38">
                  TU HERRAMIENTA DE EMERGENCIA
                </span>
              </h2>

              <div className="flex flex-col md:flex-row gap-8 items-center mt-8" data-id="element-39">
                <img src="https://cdn.magicpatterns.com/uploads/qp4wePXbTezKC4oV3FpZay/portada_audio_formato_web.webp" alt="Audio S.O.S. - Tu Salvavidas" className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-2xl object-cover shadow-lg border-2 border-gold/20" data-id="element-40" />

                <div className="space-y-4 text-brown-light text-lg leading-relaxed" data-id="element-41">
                  <p data-id="element-42">Cuando todo explota — no puedes leer. No puedes pensar.</p>
                  <p data-id="element-43">
                    Por eso el ebook incluye un audio especial. Dale play cuando
                    sientas que ya no puedes. Te guía a respirar. Te devuelve al
                    presente. Te recuerda que puedes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}